import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row lg:mr-auto lg:ml-0 mx-auto" }
const _hoisted_3 = { class: "px-5" }
const _hoisted_4 = { class: "py-6" }
const _hoisted_5 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_6 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_7 = { class: "p-1 m-1 text-center" }
const _hoisted_8 = { class: "text-center" }

import { inject, onMounted, ref, watch } from "vue";
import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import CommissionSummaryDialog from "@/components/dialogs/CommissionSummaryDialog.vue";
import { formatNumber, translate } from "@/utils/tools";
import DateSelector from "@/components/tools/DateSelector.vue";
import DropdownComponent from "@/components/tools/DropdownComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyInfo',
  setup(__props) {

dayjs.extend(localizedFormat);

const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const userData: any = ref([]);
const advanceFilterModal = ref<boolean>(false);
const detailDialogModal = ref<boolean>(false);
const showErrorDetail = ref<boolean>(false);
const errorMessage = ref<string>("");
const dateSelectorRef = ref();

const selectedOption = ref({
  label: "Last 30 Days",
  value: dayjs().add(-30, "day").format(),
});

const months: any = ref([]);
const beginningDate = "2022-01-01";
const diff = dayjs().diff(beginningDate, "months");
for (let i = 0; i <= diff; i++) {
  months.value.push({
    label: dayjs(beginningDate).add(i, "month").format("MM/YYYY"),
    value: dayjs(beginningDate).add(i, "month").format(),
  });
}
months.value.push(
  {
    label: "Last 30 Days",
    value: dayjs().add(-30, "day").format(),
  },
  {
    label: "Yesterday",
    value: dayjs().add(-1, "day").format(),
  }
);

const onMonthChange = (data: any) => {
  selectedOption.value = data;
  filterByMonth(data);
};

const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.startDate = payload.from
    ? dayjs(payload.from).format("YYYY-MM-DD")
    : dayjs().startOf("month").format("YYYY-MM-DD");
  filterForm.value.endDate = payload.to
    ? dayjs(payload.to).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD");
  isLoaded.value = false;
  pageConfig.value.page = 1;
  fetchPageData();
};

const filterByMonth = (payload: any) => {
  let from: any = dayjs(payload.value).startOf("month").format("YYYY-MM-DD");
  let to: any = dayjs(payload.value).endOf("month").format("YYYY-MM-DD");
  if (payload.label == "Yesterday") {
    from = dayjs(payload.value)
      .add(-1, "day")
      .hour(0)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD");
    to = dayjs(payload.value)
      .hour(23)
      .minute(59)
      .second(59)
      .format("YYYY-MM-DD");
  }
  if (payload.label == "Last 30 Days") {
    (from = dayjs(payload.value)
      .add(-30, "day")
      .hour(0)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD")),
      (to = dayjs(payload.value)
        .hour(23)
        .minute(59)
        .second(59)
        .format("YYYY-MM-DD"));
  }

  dateSelectorRef.value.state = {
    from: dayjs(from).format("YYYY-MM-DD"),
    to: dayjs(to).format("YYYY-MM-DD"),
  };

  isLoaded.value = false;
  filterForm.value.startDate = from;
  filterForm.value.endDate = to;
  fetchPageData();
};

const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  search: "",
  dataLength: 0,
  isEmitOnClick: false,
  sort: [["createdAt", "DESC"]],
});
const filterForm = ref({
  moduleCode: undefined,
  roundId: undefined,
  userAlias: undefined,
  userPhone: undefined,
  userId: undefined,
  startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
  endDate: dayjs().format("YYYY-MM-DD"),
  status: undefined,
});

const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Action") attName = "action";
  if (attName === "Amount") attName = "amount";
  if (attName === "Open Amount") attName = "openAmount";
  if (attName === "Close Amount") attName = "closeAmount";
  if (attName === "Date Received") attName = "createdAt";
  sort[0] = [attName, mode === "DESC" ? "ASC" : "DESC"];
  fetchPageData(true);
};

const filterModal = (flag?: number) => {
  if (flag === 1) {
    fetchPageData(true);
  } else {
    fetchPageData(false);
  }
  advanceFilterModal.value = false;
  detailDialogModal.value = false;
};

const fetchPageData = async (reset = false) => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort } = pageConfig.value;

  if (selectedOption.value.label == "Last 30 Days") {
    dateSelectorRef.value.state = {
      from: dayjs()
        .add(-30, "day")
        .hour(0)
        .minute(0)
        .second(0)
        .format("YYYY-MM-DD"),
      to: dayjs().hour(0).minute(0).second(0).format("YYYY-MM-DD"),
    };
  }

  const { startDate, endDate } = filterForm.value;
  let offset = (page - 1) * rowsPerPage;
  if (reset) {
    offset = 0;
    pageConfig.value.page = 1;
  }

  const payload: any = {
    userId: route.params.id,
    page: page,
    pageSize: rowsPerPage,
    orderBy: [sort[0]],
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/point/transaction`
  const { rows, count } = await axios
    .post(url, payload)
    .then(({ data }) => data);

  // if(!rows || rows.length == 0){
  //   if(pageConfig.value.page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }
  pageConfig.value.dataLength = rows.length;

  dataRows.value = rows;
  pageConfig.value.pageCount = Math.ceil(count / rowsPerPage);
  pageConfig.value.count = count;

  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

const columns = ref([
  {
    label: translate("messages.player.loyaltyInfo.action"),
    field: "action",
    isSorted: false,
    sort: false,
  },
  {
    label: translate("messages.player.loyaltyInfo.amount"),
    field: "amount",
    isSorted: false,
    sort: false,
    format: (data: any) => data.amount,
    class: (data: any) => {
      if (Number(data.amount) < 0 || data.action === "POINT_BURN") {
        return "text-red-500";
      } else if (data.action === "POINT_ADJUST") {
        return "text-yellow-500";
      } else {
        return "text-green-500";
      }
    },
  },
  {
    label: translate("messages.player.loyaltyInfo.openAmount"),
    field: "openAmount",
    isSorted: false,
    sort: false,
    format: (data: any) => data.openAmount,
  },
  {
    label: translate("messages.player.loyaltyInfo.closeAmount"),
    field: "closeAmount",
    isSorted: false,
    sort: false,
    format: (data: any) => data.closeAmount,
  },
  {
    label: translate("messages.loyaltyInfo.action"),
    field: "action",
    isSorted: false,
    sort: false,
  },
  {
    label: translate("messages.player.loyaltyInfo.remarks"),
    field: "remark",
    isSorted: false,
    sort: false,
  },
  {
    label: translate("messages.player.loyaltyInfo.dateReceived"),
    field: "createdAt",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
]);

watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(DropdownComponent, {
            modelValue: selectedOption.value,
            options: months.value,
            onOnOptionSelected: onMonthChange
          }, null, 8, ["modelValue", "options"])
        ]),
        _createVNode(DateSelector, {
          onSearch: onSearch,
          ref_key: "dateSelectorRef",
          ref: dateSelectorRef
        }, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: doSort,
            isLoaded: isLoaded.value
          }, null, 8, ["columns", "data", "isLoaded"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ]),
    _createVNode(CommissionSummaryDialog, {
      show: detailDialogModal.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((detailDialogModal).value = $event)),
      userData: userData.value,
      onSubmit: _cache[2] || (_cache[2] = ($event: any) => (filterModal(0)))
    }, null, 8, ["show", "userData"]),
    _createVNode(DialogComponent, { isOpen: showErrorDetail.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, _toDisplayString(errorMessage.value), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "bg-red-500 rounded p-2 text-white",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showErrorDetail.value = false))
          }, _toDisplayString(_ctx.$t("messages.player.loyaltyInfo.close")), 1)
        ])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}
}

})